import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowleftIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="arrowleft_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="m323.584 462.293 262.23-194.389a60.416 60.416 0 0 1 85.077 13.312c7.68 10.581 11.776 23.339 11.776 36.437v388.694c0 34.048-27.264 61.653-60.886 61.653-12.928 0-25.514-4.181-35.968-11.904L323.584 561.749a62.123 62.123 0 0 1 0-99.498z"
    />
  </svg>
);
export default SvgArrowleftIcon;
